import { render, staticRenderFns } from "./multiCommunityFeeSummaryList.vue?vue&type=template&id=30860b41&scoped=true"
import script from "./multiCommunityFeeSummaryList.vue?vue&type=script&lang=js"
export * from "./multiCommunityFeeSummaryList.vue?vue&type=script&lang=js"
import style0 from "./multiCommunityFeeSummaryList.vue?vue&type=style&index=0&id=30860b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30860b41",
  null
  
)

export default component.exports